import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { criteriaModalMessages as messages } from "../../../orchestrator.messages";

interface StringListInputProps {
  value: string;
  onChange: (value: string) => void;
}

export function StringListInput({ value, onChange }: StringListInputProps) {
  const intl = useIntl();

  return (
    <div>
      <label className="block text font-medium text-gray-700 mb-1">
        <FormattedMessage {...messages.values} />
      </label>
      <input
        type="text"
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={intl.formatMessage(messages.valuesPlaceholder)}
        className="w-full border rounded px-3 py-2"
      />
      <div className="text-gray-500 text-xs mt-1">
        <FormattedMessage {...messages.valuesHelper} />
      </div>
    </div>
  );
}
